// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  padding: 0 10px;
  --background: transparent !important;
}

.promo-info {
  align-items: center;
  padding: 10px 17px;
  background: white;
  margin: 10px 10px 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 14px;
  display: none;
}
.promo-info .name {
  width: 180px;
}

.min-order {
  margin: 10px 10px 0;
}

.add-more {
  margin-top: 2rem;
  cursor: pointer;
}
.add-more .add-block {
  height: 48px;
  width: 100%;
  border: 1px solid #a4b4a9;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.add-more ion-icon {
  margin-right: 10px;
}
.add-more .add-sign {
  color: var(--ion-color-primary);
  font-size: 20px;
}
.add-more .add-text {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.01em;
  text-align: left;
  color: var(--ion-color-primary);
}

.card-actions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-button.invalid {
  background: darkgrey;
  color: grey;
}

.wrapper {
  max-height: 100%;
  flex-direction: column;
  display: flex;
  height: 100%;
}

.promo-row {
  margin: 0 16px;
  border-top: 0.5px solid #a2834f;
  border-bottom: 0.5px solid #a2834f;
  padding-block: 12px;
}
.promo-row .promo-col {
  margin: 0;
  padding: 0;
}

.article {
  text-align: center;
  height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media (max-width: 992px) {
  .article {
    height: 35px;
  }
}

.ordered-articles-container {
  flex: 1;
  overflow: auto;
  padding-inline: 16px;
  padding-block: 20px;
}

.title {
  padding: 20px 16px 0;
  margin: 0;
  font-family: Capture;
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  font-weight: normal !important;
}

.promo-error {
  margin: 10px;
  font-size: 13px;
  text-align: center;
  color: red;
  display: none;
}

.add-to-order-button {
  margin: 4px 12px 12px 12px;
}

app-payment-methods-display {
  margin: 0 12px;
  display: block;
}

.footer-btn {
  padding: 12px 16px 17px;
  background-color: #fff;
}

.promo-block {
  padding: 12px;
  color: var(--ion-color-main);
  margin: 0px 15px 10px;
  background: #ffffff;
  border-radius: 5px;
  border: 0.5px solid #e2dcd5;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  line-height: 20px;
  color: var(--ion-color-dark);
  font-family: AppFontMedium, sans-serif;
}
.promo-block__info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.promo-block .price {
  color: var(--ion-color-black);
}

.recommenation_section {
  padding: 17px 16px 12px;
  width: 100%;
  overflow: hidden;
  background-color: #fff;
  box-shadow: -5px 0px 56px 0px rgba(0, 0, 0, 0.0901960784);
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.recommenation_section .recom_title {
  margin: 0 0 6px;
  font-family: AppFont;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.6px;
  letter-spacing: 0.03em;
  color: var(--color-black);
}
.recommenation_section .recommenation_section_articles {
  overflow-x: auto;
  padding-block: 8px;
  margin-inline: -8px;
}
.recommenation_section .recommenation_section_articles::-webkit-scrollbar {
  display: none;
}
.recommenation_section .recommended_track {
  display: flex;
  align-items: stretch;
  gap: 12px;
  padding-inline: 8px;
  box-sizing: border-box;
  width: max-content;
  scroll-snap-type: x proximity;
}
.recommenation_section .recommended_item {
  position: relative;
  scroll-snap-align: start;
  width: 110px;
  height: 180px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0 0 15px 0 rgba(125, 93, 40, 0.1);
}
.recommenation_section .recommended_item__image {
  width: 100%;
  height: 72px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 8px;
}
.recommenation_section .recommended_item__image ion-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.recommenation_section .recommended_item .name {
  margin: 0;
  font-family: AppFont;
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  letter-spacing: 0.01em;
  color: var(--color-black);
  text-align: start;
  word-break: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommenation_section .recommended_item .price_row {
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.recommenation_section .recommended_item .price_recom {
  margin: 0;
  font-family: AppFontMedium;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0.02em;
  text-align: left;
  color: var(--color-black);
}
.recommenation_section .recommended_item .action_icon {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1efea;
}
.recommenation_section .recommended_item .action_icon ion-icon {
  width: 8.88px;
  height: 9.5px;
}
.recommenation_section .default-img {
  object-fit: contain !important;
  background-color: transparent;
}
.recommenation_section::after {
  content: "";
  display: block;
  width: 97%;
  margin: 20px auto 0;
  height: 16px;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.08) 0, rgba(0, 0, 0, 0.08) 1px, transparent 1px, transparent 11px, rgba(0, 0, 0, 0.08) 11px, rgba(0, 0, 0, 0.08) 12px, transparent 12px);
}

app-order-list {
  display: block;
  transform: translateZ(0);
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-content/order-content.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAIA;EACC,eAAA;EACA,oCAAA;AAHD;;AAMA;EACC,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,eAAA;EAMA,aAAA;AARD;AAIC;EACC,YAAA;AAFF;;AAQA;EACC,mBAAA;AALD;;AAQA;EACC,gBAAA;EACA,eAAA;AALD;AAOC;EACC,YAAA;EACA,WAAA;EAEA,yBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAPF;AAUC;EACC,kBAAA;AARF;AAWC;EACC,+BAAA;EACA,eAAA;AATF;AAWC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EAEA,sBAAA;EACA,gBAAA;EACA,+BAAA;AAVF;;AAgBA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAbD;;AAgBA;EACC,oBAAA;EACA,WAAA;AAbD;;AAgBA;EACC,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AAbD;;AAgBA;EACC,cAAA;EACA,+BAAA;EACA,kCAAA;EACA,mBAAA;AAbD;AAeC;EACC,SAAA;EACA,UAAA;AAbF;;AAiBA;EACC,kBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAdD;ACjFE;ED0FF;IAOE,YAAA;EAZA;AACF;;AAeA;EACC,OAAA;EACA,cAAA;EACA,oBA7GgB;EA8GhB,mBAAA;AAZD;;AAeA;EACC,oBAAA;EACA,SAAA;EACA,oBAAA;EACA,yBAAA;EACA,iCAAA;EACA,8BAAA;AAZD;;AAcA;EACC,YAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AAXD;;AAcA;EACC,0BAAA;AAXD;;AAcA;EACC,cAAA;EACA,cAAA;AAXD;;AAcA;EACC,uBAAA;EACA,sBAAA;AAXD;;AAcA;EACC,aAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,sCAAA;AAXD;AAaC;EACC,aAAA;EACA,mBAAA;EACA,2BAAA;AAXF;AAcC;EACC,6BAAA;AAZF;;AAgBA;EACC,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,yDAAA;EACA,4BAAA;EACA,6BAAA;AAbD;AAeC;EACC,eAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;AAbF;AAeC;EACC,gBAAA;EACA,kBAAA;EACA,mBAAA;AAbF;AAeE;EACC,aAAA;AAbH;AAiBC;EACC,aAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;AAfF;AAkBC;EACC,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;EACA,6CAAA;AAhBF;AAkBE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AAhBH;AAkBG;EACC,WAAA;EACA,YAAA;EACA,mBAAA;AAhBJ;AAoBE;EACC,SAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAlBH;AAqBE;EACC,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;AAnBH;AAsBE;EACC,SAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AApBH;AAuBE;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AArBH;AAuBG;EACC,aAAA;EACA,aAAA;AArBJ;AA0BC;EACC,8BAAA;EACA,6BAAA;AAxBF;AA2BC;EACC,WAAA;EACA,cAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,qMAAA;AAzBF;;AAsCA;EACC,cAAA;EACA,wBAAA;AAnCD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n$padding-inline: 16px;\n\nion-content {\n\tpadding: 0 10px;\n\t--background: transparent !important;\n}\n\n.promo-info {\n\talign-items: center;\n\tpadding: 10px 17px;\n\tbackground: white;\n\tmargin: 10px 10px 0;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\n\t.name {\n\t\twidth: 180px;\n\t}\n\n\tdisplay: none;\n}\n\n.min-order {\n\tmargin: 10px 10px 0;\n}\n\n.add-more {\n\tmargin-top: 2rem;\n\tcursor: pointer;\n\n\t.add-block {\n\t\theight: 48px;\n\t\twidth: 100%;\n\n\t\tborder: 1px solid #a4b4a9;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 5px;\n\t}\n\n\tion-icon {\n\t\tmargin-right: 10px;\n\t}\n\n\t.add-sign {\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-size: 20px;\n\t}\n\t.add-text {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 14px;\n\t\tline-height: 19px;\n\n\t\tletter-spacing: 0.01em;\n\t\ttext-align: left;\n\t\tcolor: var(--ion-color-primary);\n\n\t\t// text-transform: uppercase;\n\t}\n}\n\n.card-actions {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n}\n\n.footer-button.invalid {\n\tbackground: darkgrey;\n\tcolor: grey;\n}\n\n.wrapper {\n\tmax-height: 100%;\n\tflex-direction: column;\n\tdisplay: flex;\n\theight: 100%;\n}\n\n.promo-row {\n\tmargin: 0 $padding-inline;\n\tborder-top: 0.5px solid #a2834f;\n\tborder-bottom: 0.5px solid #a2834f;\n\tpadding-block: 12px;\n\n\t.promo-col {\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t}\n}\n\n.article {\n\ttext-align: center;\n\theight: 110px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t@include mobile {\n\t\theight: 35px;\n\t}\n}\n\n.ordered-articles-container {\n\tflex: 1;\n\toverflow: auto;\n\tpadding-inline: $padding-inline;\n\tpadding-block: 20px;\n}\n\n.title {\n\tpadding: 20px $padding-inline 0;\n\tmargin: 0;\n\tfont-family: Capture;\n\ttext-transform: uppercase;\n\tcolor: var(--ion-color-secondary);\n\tfont-weight: normal !important;\n}\n.promo-error {\n\tmargin: 10px;\n\tfont-size: 13px;\n\ttext-align: center;\n\tcolor: red;\n\tdisplay: none;\n}\n\n.add-to-order-button {\n\tmargin: 4px 12px 12px 12px;\n}\n\napp-payment-methods-display {\n\tmargin: 0 12px;\n\tdisplay: block;\n}\n\n.footer-btn {\n\tpadding: 12px $padding-inline 17px;\n\tbackground-color: #fff;\n}\n\n.promo-block {\n\tpadding: 12px;\n\tcolor: var(--ion-color-main);\n\tmargin: 0px 15px 10px;\n\tbackground: #ffffff;\n\tborder-radius: 5px;\n\tborder: 0.5px solid #e2dcd5;\n\tbox-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tfont-size: 14px;\n\tline-height: 20px;\n\tcolor: var(--ion-color-dark);\n\tfont-family: AppFontMedium, sans-serif;\n\n\t&__info {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t}\n\n\t.price {\n\t\tcolor: var(--ion-color-black);\n\t}\n}\n\n.recommenation_section {\n\tpadding: 17px $padding-inline 12px;\n\twidth: 100%;\n\toverflow: hidden;\n\tbackground-color: #fff;\n\tbox-shadow: -5px 0px 56px 0px #00000017;\n\tborder-top-left-radius: 15px;\n\tborder-top-right-radius: 15px;\n\n\t.recom_title {\n\t\tmargin: 0 0 6px;\n\t\tfont-family: AppFont;\n\t\tfont-size: 16px;\n\t\tfont-weight: 600;\n\t\tline-height: 21.6px;\n\t\tletter-spacing: 0.03em;\n\t\tcolor: var(--color-black);\n\t}\n\t.recommenation_section_articles {\n\t\toverflow-x: auto;\n\t\tpadding-block: 8px;\n\t\tmargin-inline: -8px;\n\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t.recommended_track {\n\t\tdisplay: flex;\n\t\talign-items: stretch;\n\t\tgap: 12px;\n\t\tpadding-inline: 8px;\n\t\tbox-sizing: border-box;\n\t\twidth: max-content;\n\t\tscroll-snap-type: x proximity;\n\t}\n\n\t.recommended_item {\n\t\tposition: relative;\n\t\tscroll-snap-align: start;\n\t\twidth: 110px;\n\t\theight: 180px;\n\t\tpadding: 12px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 8px;\n\t\tcursor: pointer;\n\t\tbackground: #ffffff;\n\t\tbox-shadow: 0 0 15px 0 rgba(125, 93, 40, 0.1);\n\n\t\t&__image {\n\t\t\twidth: 100%;\n\t\t\theight: 72px;\n\t\t\tborder-radius: 12px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\toverflow: hidden;\n\t\t\tpadding: 8px;\n\n\t\t\tion-img {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: contain;\n\t\t\t}\n\t\t}\n\n\t\t.name {\n\t\t\tmargin: 0;\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 400;\n\t\t\tline-height: 15px;\n\t\t\tletter-spacing: 0.01em;\n\t\t\tcolor: var(--color-black);\n\t\t\ttext-align: start;\n\t\t\tword-break: break-word;\n\t\t\t-webkit-line-clamp: 2;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t.price_row {\n\t\t\tmargin-top: auto;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\tgap: 8px;\n\t\t}\n\n\t\t.price_recom {\n\t\t\tmargin: 0;\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 13px;\n\t\t\tline-height: 17px;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: left;\n\t\t\tcolor: var(--color-black);\n\t\t}\n\n\t\t.action_icon {\n\t\t\twidth: 19px;\n\t\t\theight: 19px;\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tbackground: #f1efea;\n\n\t\t\tion-icon {\n\t\t\t\twidth: 8.88px;\n\t\t\t\theight: 9.5px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.default-img {\n\t\tobject-fit: contain !important;\n\t\tbackground-color: transparent;\n\t}\n\n\t&::after {\n\t\tcontent: '';\n\t\tdisplay: block;\n\t\twidth: 97%;\n\t\tmargin: 20px auto 0;\n\t\theight: 16px;\n\t\tbackground-image: linear-gradient(\n\t\t\tto bottom,\n\t\t\trgba(0, 0, 0, 0.08) 0,\n\t\t\trgba(0, 0, 0, 0.08) 1px,\n\t\t\ttransparent 1px,\n\t\t\ttransparent 11px,\n\t\t\trgba(0, 0, 0, 0.08) 11px,\n\t\t\trgba(0, 0, 0, 0.08) 12px,\n\t\t\ttransparent 12px\n\t\t);\n\t}\n}\n\napp-order-list {\n\tdisplay: block;\n\ttransform: translateZ(0);\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
